const container = document.querySelector(".webshop__product-image-preview");
if (container) {
    const buttons = document.querySelectorAll('.webshop__product-image-button');
    if (buttons.length) {
        const largeImage = document.getElementById('webshop__product-large-image');
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', () => {
                largeImage.src = buttons[i].src;
            });
        }
    }
}

const radio_size_all = document.querySelectorAll(".webshop__product-details-size-radio");
const price_div_all = document.querySelectorAll(".webshop__product-purchase-price-div");
const amount_select_all = document.querySelectorAll(".webshop__product-details-amount-select");
if (radio_size_all) {
    const label_elements = document.querySelectorAll('.webshop__product-details-size-label');
    if (label_elements.length) {
        for (let i = 0; i < label_elements.length; i++) {
            label_elements[i].addEventListener('click', () => {
                let current_id = label_elements[i].id;
                let current_price_div = document.getElementById('webshop__product-purchase-price-'+current_id);
                let current_amount_select = document.getElementById('webshop__product-details-amount-select-'+current_id);
                let current_radio_size = document.getElementById('webshop__product-details-size-radio-'+current_id);
                if (typeof radio_size_all === 'undefined' || radio_size_all === null || radio_size_all.length < 1) {
                    return;
                }
                if (typeof current_price_div === 'undefined' || current_price_div === null) {
                    return;
                }
                if (typeof current_amount_select === 'undefined' || current_amount_select === null) {
                    return;
                }
                if (typeof current_radio_size === 'undefined' || current_radio_size === null) {
                    return;
                }
                if (current_radio_size.disabled) {
                    return;
                }
                for (let j = 0; j < radio_size_all.length; j++) {
                    radio_size_all[j].checked = false;
                }
                for (let j = 0; j < price_div_all.length; j++) {
                    price_div_all[j].classList.remove("webshop__product-purchase-price-div--active");
                }
                for (let j = 0; j < amount_select_all.length; j++) {
                    amount_select_all[j].classList.remove("webshop__product-details-amount-select--active");
                }
                document.getElementById('purchasableId').value = current_id;
                document.getElementById('qty').value = current_amount_select.value;
                current_radio_size.checked = true;
                current_price_div.classList.add("webshop__product-purchase-price-div--active");
                current_amount_select.classList.add("webshop__product-details-amount-select--active");
            });
        }
    }
}

const radio_shipping_all = document.querySelectorAll(".delivery__form-item-radio");
if (radio_shipping_all) {
    const label_elements = document.querySelectorAll('.delivery__form-item-label');
    if (label_elements.length) {
        for (let i = 0; i < label_elements.length; i++) {
            label_elements[i].addEventListener('click', () => {
                let current_id = label_elements[i].id;
                let current_radio_shipping = document.getElementById('delivery__form-item-radio-' + current_id);
                if (typeof radio_shipping_all === 'undefined' || radio_shipping_all === null || radio_shipping_all.length < 1) {
                    return;
                }
                for (let j = 0; j < radio_shipping_all.length; j++) {
                    radio_shipping_all[j].checked = false;
                }
                current_radio_shipping.checked = true;

                let addresses = document.querySelectorAll('.delivery__form-item-pickup-address');

                for (index = 0; index < addresses.length; index++) {
                    if( addresses[index] ){
                        addresses[index].classList.remove('delivery__form-item-pickup-address--active');
                    }
                }

                let current_address_shipping = document.getElementById('delivery__form-item-address-' + current_id);
                if (current_address_shipping) {
                    current_address_shipping.classList.toggle("delivery__form-item-pickup-address--active");
                }
                
            });
        }
    }
}

const flashnotice = document.querySelectorAll(".flashnotice");
if (flashnotice && flashnotice.length>0) {
    let flashnoticeElement = flashnotice[0];
    if (flashnoticeElement) {
        setTimeout( function () {
            fade(flashnoticeElement);
        }, 4000);
    }
}

function fade(element) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
            clearInterval(timer);
            element.style.display = 'none';
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
    }, 50);
}